import { Routes as RouterRoutes, Route } from "react-router-dom";
import { dashboard as dashboardRoutes } from "./index";
import DashboardLayout from "../layouts/DashboardLayout";
import { Box } from "@mui/material";
import { useAuth } from "../contexts/authContext";
import { useTracking } from "react-tracking";
import { sendTrackingData } from "../services/trackingService";

// react-router v7: nested config replaced with element/Routes (no Switch / no `exact`).
// The BrowserRouter lives in main.tsx — no <Router history={...}/> here.
const renderRoutes = (Layout, routes, hasRole) =>
    routes.flatMap(({ children, path, userGuide, component: Component }, index) =>
        children
            ? children
                  .filter((r) => !r.requiresRole || hasRole(r.requiresRole))
                  .map(({ path: cPath, userGuide: cGuide, component: CComp, fullBleed: cFull }, cIdx) => (
                      <Route
                          key={`${index}-${cIdx}`}
                          path={cPath}
                          element={
                              // fullBleed routes render their own shell (e.g. the
                              // Tandem console) and bypass the DashboardLayout chrome.
                              cFull ? (
                                  <CComp />
                              ) : (
                                  <Layout userGuide={cGuide}>
                                      <CComp />
                                  </Layout>
                              )
                          }
                      />
                  ))
            : [
                  <Route
                      key={index}
                      path={path}
                      element={
                          <Layout userGuide={userGuide}>
                              <Component userGuide />
                          </Layout>
                      }
                  />,
              ]
    );

const Routes = () => {
    const { hasRole } = useAuth();

    const { Track } = useTracking(
        {},
        {
            dispatch: sendTrackingData,
            process: (ownTrackingData) =>
                ownTrackingData.page ? { event: "pageView" } : null,
        }
    );

    return (
        <Track>
            <Box display="flex">
                <Box flexGrow={1} style={{ width: "100%" }}>
                    <RouterRoutes>
                        {renderRoutes(DashboardLayout, dashboardRoutes, hasRole)}
                    </RouterRoutes>
                </Box>
            </Box>
        </Track>
    );
};

export default Routes;
